export default {
  en: {
    'components.entity-selector.multiple-entity-selected': 'Multiple entities selected',
    'components.entity-selector.multiple-countries-selected': 'Multiple',
    'components.entity-selector.select-entity': 'Please select an entity',
    'components.entity-selector.select': 'Select',
  },
};
